<!-- 文字单行显示超出部分。。。 tooltip显示 -->
<template>
    <div class="tooltip-wrap">
         <el-tooltip
            ref="tip"
            :disabled="!toolripFlag"
            :content="tooltipText"
            effect="dark"
            :placement="placement"
        >
            <span @mouseenter="visibilityChange($event)">{{ tooltipText }}</span>
        </el-tooltip>
    </div>
   
</template>

<script>
export default {
    name: 'EllipsisTooltip',
    props: {
        // 文本内容
        tooltipText: {
            type: String,
            default: ''
        },
        placement: {
            type: String,
            default: 'top-start'
        }
    },
    data() {
        return {
            toolripFlag: false
        }
    },
    methods: {
        visibilityChange(event) {
            const ev = event.target
            const ev_height = ev.offsetHeight // 文本实际高度
            const content_height = this.$refs.tip.$el.parentNode.clientHeight // 文本容器高度
            if (content_height < ev_height) {
                this.toolripFlag = true
            } else {
                this.toolripFlag = false
            }
        }
    },
}
</script>

<style lang='less' scoped>
    .tooltip-wrap {
        height: 20px;
        display: inline-block;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        cursor: pointer;
        line-height: 22px;
        color: #2e2f3c;
        font-family: MicrosoftYaHei;
        text-overflow: ellipsis;
        word-break: break-all;
        font-size: 14px;
        width: calc(100% - 70px);
        span {
            line-height: 22px;
        }
    }
</style>